const Template = () => {
	return (
		<div>Template</div>
	);
};

export default Template;